import { useParams } from 'react-router-dom';

export const hackList = {
  isScheduleDefaultList: ['2025-hillrobinson-company-seminar', 'digital1to1-winter-2023', 'tince23', 'digital1to1-italy-2023', 'digital1to1-travel-2023', 'retailluxurymbaforum', 'digital1to1-spring-2024', 'alpuraconave2024', 'convencion2024', 'abril24', 'juin2024', 'digital1to1-summer-2024', 'junio24', 'auumm2024', 'fpa2024', 'agosto24', 'digital1to1-italy-2024', 'digital1to1-winter-2024', 'digital-connection-2024', 'salonmonetiqueregional', 'noviembre24', 'digital1to1-travel-2024', 'febrero25', 'digital1to1-spring-spain-2025', 'worldwide-meeting-2025', 'ipadetf2025', 'abril25', 'bbny2025', 'conectabr', 'digital1to1-spring-italy-2025', 'digital1to1-summer-2025', 'agosto25', 'digital1to1-italy-winter-2025', 'digital1to1-spain-winter-2025', 'showroom-online-2025', 'noviembre25', 'uees-showroom-online-2025', 'turnitin-sko-2026', 'febrero-2026', 'showroomonlinegrado2026', 'mayo-2026', 'juin2026', 'showroompostgradoonline2026', 'fin-pay-2026', 'healf-experience-2026', 'julio-2026', 'cima-2026', 'agosto-2026', 'octubre-2026'],
  changeDefaultLiveNowIcon: ['tince23'],
  changeLiveNowDefaultTitle: ['tince23'],
  sortAttendeesByLastName: ['tince23'],
  skipAnalyticsTrackings: ['voannualnetworkmeeting2022', 'netwirkig'],
  hackedForOnClickActivityCard: ['investorsday', 'surainvestmentforum', '11forodeemisoras'],
  isPureBlackActivityCard: ['ss23', 'netwirkig', '22pro5', 'demo-juanortega'],
  loggedOutBgLayout: ['cbg'],
  hideStageSidebar: ['netwirkig', 'pernodricardsaconference', 'journees-naturalite', 'worldwide-meeting-2025', 'dantznetworkgcongress2025'],
  hideLiveNow: ['e-glm-2022', '22pro5', 'tdc-conference-nlc', 'showroom-online-2025', 'uees-showroom-online-2025', 'seminaire-lfde', 'showroomonlinegrado2026', 'ecom-elevated-fall-2026'],
  hideTabDailyStreaming: ['elearning-africa-primary-secondary-education', 'ettc2021', 'languages_and_the_media'],
  hideMainStage: ['50b1', 'jli-global-essay-prize-2024', 'vibe2025', 'df25', 'boostyournetwork2025', 'bbny2025', 'juin2025', 'bbhk2025', 'bbmi2025', 'rencontrescampusfrance2025', 'vibe2026', 'bbpm2025', 'gst2025', 'tiffanywatchweek2026', 'ecom-elevated-spring-utah', 'jornada-de-articulacion-para-el-comercio-exterior', 'it_medellin26', 'juin2026', 'ecom-elevated-fall-2026', 'hkbb2026', 'uri-6579dabc-9b70-4', 'healf-experience-2026', 'bbvenice2026', 'vibe-2027'],
  hideAttendeeTypesFilter: ['assisesausim2024'],
  hideWaitingMessage: ['gifas-delegation-to-india'],
  changeOrderSponsorsByAmount: ['gifas-delegation-to-india'],
  changeSpeakersSubtitle: ['worldwide-meeting-2025'],
  hideBiographyText: ['worldwide-meeting-2025'],
  termsAndConditions: ['worldwide-meeting-2025'],
  hideQrCode: ['elcongress2025', 'dtt-macau-2026'],
  customRegisterUrl: ['app-growth-annual-2025'],
  defaultDarkMode: ['healf-experience-2026'],
  hideDayView: ['healf-experience-2026'],
  showWorkshopCategory: ['healf-experience-2026'],
  hideWorkshopCalendarIcon: ['healf-experience-2026'],
  hideWorkshopAddToCalendar: ['ic2021', 'healf-experience-2026'],
  borderedWorkshopListItem: ['healf-experience-2026'],
};

const configs = {
  limitLocaleDropdownOptions:
    {
      '2022edition': ['en', 'tr'],
      networkingeventtia: ['en', 'es'],
      'demo-juanortega': ['en', 'es'],
    },
  changeSpeakersSubtitle:
    {
      'worldwide-meeting-2025': 'If you require any assistance, please do not hesitate to contact the WWM team.',
    },
  termsAndConditions: {
    'worldwide-meeting-2025': {
      termsFieldInternalId: 'terms',
      agreementText: 'By attending the 2025 Worldwide Meeting, you agree to keep all information shared during this event strictly confidential and not to disclose, use, copy, reproduce, or record any part of it, as specified in the General Terms of Use of the present platform.',
      textToLink: 'General Terms of Use',
    },
  },
  customRegisterUrl: {
    'app-growth-annual-2025': 'https://appgrowthannual.com/virtual',
  },
  changeCategoriesTypesLabelName: {
    'healf-experience-2026': 'Location',
  },
};

const useHack = (hackName) => {
  const { eventUri } = useParams();
  return hackList[hackName]?.includes(eventUri);
};

export const useEventUriHackConfig = (hackName) => {
  const { eventUri } = useParams();
  const hackConfig = configs[hackName];

  return hackConfig?.[eventUri];
};

export default useHack;
